export default "__VITE_ASSET__8gDtJBOE__"